import { useContext, useEffect, useState } from 'react';
import { TestingHqContext } from '../../context/TestingHqContext';
import { get_testing_place_list, upsert_testing_place } from '../../utils/restapi';
import './report_join.css';

const TestingReportJoin = ({ testingScheduleObj, onClose }) => {
  const { testingHqs } = useContext(TestingHqContext);

  // 선택상자 목록들
  const [testingPlaceObj, setTestingPlaceObj] = useState(null);

  // 고사장선택 목록
  const [testingPlaces, setTestingPlaces] = useState([]);

  // 고사장에 대한 데이터 가져오기
  const getTestingPlaces = async () => {
    console.log(`getTestingPlaces called`);

    if (testingScheduleObj.testing_id === undefined) {
      setTestingPlaces([]);
      return;
    }

    const json = {
      testing_id: testingScheduleObj.testing_id,
      hcodes: testingHqs.map(hq => hq.code).join(',')
    };

    console.log("getTestingPlace params:", json);

    try {
      const response = await get_testing_place_list(json);
      console.log("getTestingPlaces:", response);
      setTestingPlaces(response.lists || []);
    } catch (error) {
      console.error("Error fetching place:", error);
      setTestingPlaces([]);
    }
  };

  const handleTestingPlaceChange = async (e) => {
    console.log("handleTestingPlaceChange:", e.target.value);
    const selectedId = Number(e.target.value);
    if (!selectedId) {
      setTestingPlaceObj(null);
      return;
    }
    const selectedPlace = testingPlaces.find(place => place.testing_place_id === selectedId);
    setTestingPlaceObj(selectedPlace || null);
  };

  const handleSave = async () => {
    console.log("handleSave:", testingPlaceObj);
    try {
      const json = testingPlaceObj;
      const response = await upsert_testing_place(json);
      console.log("Save response:", response);
      // 저장 로직 추가
      alert('저장되었습니다.');
    } catch (error) {
      console.error("Error saving data:", error);
      alert('저장 중 오류가 발생했습니다.');
    }
    // ...
    onClose();
  };

  useEffect(() => {
    getTestingPlaces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingHqs.length]);
  
  return (
    <div id="testing_report_join">
      <div className="head">
        <h1>시험결과 보고</h1>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>시험</label>
            <span>
              {testingScheduleObj?.testingObj?.typeName}
              {testingScheduleObj?.testingObj?.title}
              ({testingScheduleObj?.testStartDate} ~ {testingScheduleObj?.testStopDate})
            </span>
          </li>
          <li>
            <label>고사장</label>
            <span>
              <select
                value={testingPlaceObj?.testing_place_id ?? ''}
                onChange={handleTestingPlaceChange}
              >
                <option value="">▒ 선택 ▒</option>
                {testingPlaces.map(place => (
                  <option key={place.testing_place_id} value={place.testing_place_id}>
                    {place.name}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>응시자수</label>
            <span>
              { testingPlaceObj?.accept_users ?? 0 }명
            </span>
          </li>
          <li>
            <label>답안제출자수</label>
            <span>
              <input type="number" min="0" value={testingPlaceObj?.result_users ?? 0} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, result_users: e.target.value })} />명
            </span>
          </li>
          <li>
            <label>결시자수</label>
            <span>
              <input type="number" min="0" value={testingPlaceObj?.noshow_users ?? 0} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, noshow_users: e.target.value })} />명
            </span>
          </li>
          <li>
            <label>부정행위 및 규정위반 수험자수</label>
            <span>
              <input type="number" min="0" value={testingPlaceObj?.blacklist_users ?? 0} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, blacklist_users: e.target.value })} />명
            </span>
          </li>
          <li>
            <label>시험지인쇄 상태</label>
            <span>
              <input id="isOkPrint1" type="radio" name="data[isOkPrint]" value="1" checked={testingPlaceObj?.data?.isOkPrint === 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isOkPrint: 1 } })} />
              <label htmlFor="isOkPrint1">양호</label>
              <input id="isOkPrint0" type="radio" name="data[isOkPrint]" value="0" checked={testingPlaceObj?.data?.isOkPrint !== 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isOkPrint: 0 } })} />
              <label htmlFor="isOkPrint0">불량</label>
            </span>
          </li>
          <li>
            <label>수검 인원 변동사항</label>
            <span>
              <input id="isChangeAccepts1" type="radio" name="data[isChangeAccepts]" value="1" checked={testingPlaceObj?.data?.isChangeAccepts === 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isChangeAccepts: 1 } })} />
              <label htmlFor="isChangeAccepts1">양호</label>
              <input id="isChangeAccepts0" type="radio" name="data[isChangeAccepts]" value="0" checked={testingPlaceObj?.data?.isChangeAccepts !== 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isChangeAccepts: 0 } })} />
              <label htmlFor="isChangeAccepts0">불량</label>
            </span>
          </li>
          <li>
            <label>검정 진행 사항</label>
            <span>
              <input id="isTesting1" type="radio" name="data[isTesting]" value="1" checked={testingPlaceObj?.data?.isTesting === 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isTesting: 1 } })} />
              <label htmlFor="isTesting1">양호</label>
              <input id="isTesting0" type="radio" name="data[isTesting]" value="0" checked={testingPlaceObj?.data?.isTesting !== 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isTesting: 0 } })} />
              <label htmlFor="isTesting0">불량</label>
            </span>
          </li>
          <li>
            <label>문제점 발견사항</label>
            <span>
              <input id="isNotProblem1" type="radio" name="data[isNotProblem]" value="1" checked={testingPlaceObj?.data?.isNotProblem === 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isNotProblem: 1 } })} />
              <label htmlFor="isNotProblem1">없음</label>
              <input id="isNotProblem0" type="radio" name="data[isNotProblem]" value="0" checked={testingPlaceObj?.data?.isNotProblem !== 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isNotProblem: 0 } })} />
              <label htmlFor="isNotProblem0">있음</label>
            </span>
          </li>
          <li>
            <label>부정행위자 적발</label>
            <span>
              <input id="isNotBlack1" type="radio" name="data[isNotBlack]" value="1" checked={testingPlaceObj?.data?.isNotBlack === 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isNotBlack: 1 } })} />
              <label htmlFor="isNotBlack1">없음</label>
              <input id="isNotBlack0" type="radio" name="data[isNotBlack]" value="0" checked={testingPlaceObj?.data?.isNotBlack !== 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isNotBlack: 0 } })} />
              <label htmlFor="isNotBlack0">있음</label>
            </span>
          </li>
          <li>
            <label>수험 상이자 적발</label>
            <span>
              <input id="isNotAccept1" type="radio" name="data[isNotAccept]" value="1" checked={testingPlaceObj?.data?.isNotAccept === 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isNotAccept: 1 } })} />
              <label htmlFor="isNotAccept1">없음</label>
              <input id="isNotAccept0" type="radio" name="data[isNotAccept]" value="0" checked={testingPlaceObj?.data?.isNotAccept !== 1} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, isNotAccept: 0 } })} />
              <label htmlFor="isNotAccept0">있음</label>
            </span>
          </li>
        </ul>
      </div>
      <div className="foot">
        <button onClick={handleSave}>저장</button>
        <button onClick={() => onClose()}>닫기</button>
      </div>
    </div>
  );
};

export default TestingReportJoin;